<template>
    <div class="project-edit layout-max-width">
        <data-form :title="`Edit Project${projectName ? (': ' + projectName) : ''}`"
                   tag="project-edit-title"
                   ref="projectEdit"
                   :auto-save="true"
                   save-button-label="Submit"
                   :field-model="projectFields"
                   :field-groups="fieldGroups"
                   :field-group-tabs="fieldGroupTabs"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/project/list"
                   submit-success-message="Project Created"
                   submit-error-message="Error Creating Project"
                   :submit-success-route="'/project/list'"
                   v-on:changed-tab="tabChanged"
                   v-on:changed="formChanged">
        </data-form>
        <b-alert show>
            If you can't find the company or project manager you are looking for, send an invitation below.<br>
            Once they complete their registration, they will be added to the project.
        </b-alert>
        <project-invitations :project-id="projectId" :agency-id="project.agency_id" v-if="project"/>
    </div>
</template>

<script>

import Vue from 'vue'
import ProjectFields from '@/models/Project'

/**
 * Page for admin to edit project information
 */
export default Vue.extend({
    name: 'ProjectEdit',
    props: {
        projectId: Number,
    },
    data () {
        return {
            projectFields: ProjectFields,
            projectName: null,
            fieldGroups: [
                ['name', 'agency_id', 'department', 'project_number', 'dollar_value', 'proceed_date', 'end_date', 'manager_type', 'projectManagerInspector', 'projectOwnerRepresentative'],
                ['primeCompanies', 'subCompanies'],
                ['location'],
                ['notes'],
            ],
            fieldGroupTabs: [
                { title: 'Project Info', },
                { title: 'Contractors', lockedBy: [0] },
                { title: 'Location', lockedBy: [0] },
                { title: 'Notes', lockedBy: [0] },
            ],
            tabIndex: 0,
            project: null
        }
    },
    computed: {
        showInvite () {
            return this.tabIndex === 2
        }
    },
    methods: {
        async loadModelInstance () {
            const item = await this.$api.getItem(this, 'project', this.projectId, ['primeCompanies', 'subCompanies'])
            this.projectName = item.name
            this.project = item
            return item
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'project', modelInstance)
        },
        formChanged (fieldName, form) {
            if (fieldName === 'name') {
                this.projectName = form[fieldName]
            }
        },
        tabChanged (index) {
            this.tabIndex = index
        }
    }
})

</script>

<style lang="scss">
.project-edit {

    .tab-pane:first-child, .tab-pane.active:first-child {
        @media(min-width: 768px) {
            display: flex;
            justify-content: space-between;
            //align-items: baseline;
            flex-wrap: wrap;
            .data-form-input {
                width: 24%;
            }
            .i-projectManagerInspector, .i-projectOwnerRepresentative {
                width: 100%;
            }

        }
    }

    .tab-pane:nth-child(2), .tab-pane:nth-child(3), .tab-pane.active:nth-child(2), .tab-pane.active:nth-child(3) {
        @media(min-width: 768px) {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            flex-wrap: wrap;
            .data-form-input {
                width: 49%;
            }
        }
    }


}

</style>